<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import { PaymentPath } from "@/path.js";
import axios from 'axios';

export default {
  components: { PaymentPath },
  props: ["order"],
  data() {
    return {
      logs: [],
      log_fields: ["payment_id", "status", "updated_at", "amount"],
      currentPage: 1,
      paymentOrder: null,
      options: {},
      rzp: null,
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
    };
  },
  methods: {
    openPayment() {
      console.log(this.options);
      this.rzp = new Razorpay(this.options);
      console.log(this.rzp);
      this.rzp.open();
    },
    async getPaymentOrder() {
      try {
        let res = await axios.get(
          this.baseUrl + PaymentPath.GET_ORDER_PAYMENT,
          {
            params: {
              order_id: this.order.id,
            },
          }
        );
        if (res.data.status) {
          this.paymentOrder = res.data.data;
          if (this.paymentOrder && this.paymentOrder.status != "paid") {
            this.options = {
              key: process.env.VUE_APP_RAZORPAY_KEY,
              amount: parseInt(this.paymentOrder.amount),
              currency: "INR",
              name: "Dilfoods",
              description: "",
              image: process.env.VUE_APP_AWS_CDN + '/logo/Dil-Foods-new-logo.png',
              order_id: this.paymentOrder.payment_order_id,
              callback_url: process.env.VUE_APP_API_BACKEND_URL + "order_payment_callback",
              prefill: {
                name: this.order.restaurant.name,
                email: this.order.restaurant.email,
                contact: this.order.restaurant.phone_number != '' ? this.order.restaurant.phone_number : '9742460630',
              },
              notes: {
                address: this.order.restaurant.address,
              },
              theme: {
                color: "#A91D3A",
              },
            };            
            this.openPayment();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getPaymentOrder();
  },
};
</script>

<template>
  <b-card>
    <b-card-header>
      <!-- <b-button variant="success" @click="openPayment">Initiate Payment</b-button> -->
    </b-card-header>
    <b-card-body>
      <table class="table">
        <thead>
          <tr>
            <th>Order Id</th>
            <th>Payment Id</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="paymentOrder != null" :class="paymentOrder.status == 'paid' ? 'table-success' : ''">
            <td>{{ paymentOrder.payment_order_id }}</td>
            <td>{{ paymentOrder.latest_payment_id }}</td>
            <td>{{ paymentOrder.amount }}</td>
            <td>
              <b-badge variant="success" v-if="paymentOrder.status == 'paid'">Paid</b-badge>
              <b-badge variant="primary" v-if="paymentOrder.status == 'created'">Created</b-badge>
              <b-badge variant="danger" v-if="paymentOrder.status == 'failed'">Failed</b-badge>
              <b-badge variant="warning" v-if="paymentOrder.status == 'attempted'">Attempted</b-badge>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card-body>
  </b-card>
</template>

<style></style>
